<script>
  export default {
    name: 'usage-guage',
    props: {
      percentage: {
        type: String | Number
        // default: () => 100,
      }
    },
    data: () => ({
      // percentage
    }),
    computed: {},
    methods: {},
    created() {}
  }
</script>

<template>
  <!-- 
examples 
https://codepen.io/naticaceres/pen/QWQeyGX
https://www.30secondsofcode.org/css/s/circular-progress-bar/
https://www.fullstack.com/labs/resources/blog/creating-an-svg-gauge-component-from-scratch
https://www.youtube.com/watch?app=desktop&v=H2HYccAGR00&pp=ygUYI2Nzc3Byb2dyZXNzYmFyYW5pbWF0aW9u
https://codepen.io/jagathish/pen/ZXzbzN
https://codepen.io/sosobaek/pen/pojMObQ

https://codesandbox.io/p/sandbox/half-circle-progress-bar-vjehd?file=%2Fsrc%2Fstyles.css
https://github.com/4emcos/react-semicircle-progressbar
https://codepen.io/ivanpenga/pen/RwgPbMg
https://stackoverflow.com/questions/50649381/svg-arc-progress-bar-with-constant-stroke-dasharray-object
 https://socket.dev/npm/package/react-semicircle-progressbar
 https://kimmobrunfeldt.github.io/progressbar.js/
 -->

  <div class="box gauge--1">
    <div class="progress" :style="`--percentage: ${percentage}deg;`">
      <div class="barOverflow">
        <div class="bar"></div>
      </div>
      <div class="text">{{ percentage }}%</div>
    </div>
  </div>
</template>

<style scoped>
  .progress {
    --text-offset: 15px;
    --green: #4fb493;
    --percentage: 0;
    --base-rotation: -135deg; /* 0% */
    --rotation: calc(var(--base-rotation) + var(--percentage) * 1.8);
    --red: #ff3131;
    --size: 180px;

    position: relative;
    margin: 4px;
    margin-bottom: var(--text-offset);
    float: left;
    text-align: center;
    font-size: 35px;
    font-weight: bold;
  }

  .progress .text {
    position: absolute;
    bottom: 35px;
    left: 50%;
    transform: translate(-50%, 50%);
  }

  .barOverflow {
    /* Wraps the rotating .bar */
    position: relative;
    overflow: hidden; /* Comment this line to understand the trick */
    width: var(--size);
    height: 90px; /* Half circle (overflow) */
    margin-bottom: var(--text-offset); /* bring the numbers up */
  }
  .bar {
    transform: rotate(var(--rotation));
    position: absolute;
    top: 0;
    left: 0;
    width: var(--size);
    height: var(--size); /* full circle! */
    border-radius: 50%;
    box-sizing: border-box;
    border: 20px solid var(--green); /* half gray, */
    border-bottom-color: var(--red); /* half azure */
    border-right-color: var(--red);
  }
</style>
